import types from './mutation-types'

export default {
  [types.SET_FORMULARIO] (state, payload) {
    const f = state.formulario

    f.emitente.id = payload?.id ?? null
    // Infere o tipo na edição: só é PF quando tem CPF e não tem CNPJ.
    f.emitente.tipo = (payload?.cpf && !payload?.cnpj) ? 1 : 2
    f.emitente.razao_social = payload?.razao_social ?? ''
    f.emitente.nome_fantasia = payload?.nome_fantasia ?? ''
    f.emitente.cnpj = payload?.cnpj ?? ''
    f.emitente.cpf = payload?.cpf ?? ''
    f.emitente.inscricao_municipal = payload?.inscricao_municipal ?? ''
    f.emitente.inscricao_estadual = payload?.inscricao_estadual ?? ''
    f.emitente.regime_tributario = payload?.regime_tributario ?? ''
    f.emitente.incentivador_cultural = payload?.incentivador_cultural ?? false
    f.emitente.optante_simples_nacional = payload?.optante_simples_nacional ?? false
    f.emitente.iss_retido = payload?.iss_retido ?? false
    f.emitente.possui_cadastro_fiscal = payload?.possui_cadastro_fiscal ?? false
    f.emitente.status_sincronizacao = payload?.status_sincronizacao ?? null
    f.emitente.mensagem_sincronizacao = payload?.mensagem_sincronizacao ?? null

    f.servico.codigo_issqn = payload?.codigo_tributacao_nacional_issqn ?? ''
    f.servico.cnae = payload?.codigo_cnae ?? ''
    f.servico.regime_especial = payload?.regime_especial_tributacao_municipal ?? '0'

    f.endereco.cep = payload?.cep ?? ''
    f.endereco.logradouro = payload?.logradouro ?? ''
    f.endereco.numero = payload?.numero ?? ''
    f.endereco.complemento = payload?.complemento ?? ''
    f.endereco.bairro = payload?.bairro ?? ''
    f.endereco.municipio = payload?.municipio ?? ''
    f.endereco.uf = payload?.uf ?? ''
    f.endereco.codigo_ibge = payload?.codigo_municipio_ibge ?? ''

    f.contato.telefone = payload?.telefone ?? ''
    f.contato.email = payload?.email ?? ''

    f.tributos.federais = payload?.percentual_tributos_federais ?? ''
    f.tributos.estaduais = payload?.percentual_tributos_estaduais ?? ''
    f.tributos.municipais = payload?.percentual_tributos_municipais ?? ''

    f.configuracoes.cpf_cnpj_contabilidade = payload?.cpf_cnpj_contabilidade ?? ''
    f.configuracoes.senha_certificado = '' // nasce vazio: o certificado não é persistido, nada a carregar
    f.configuracoes.logotipo_url = payload?.logotipo_url ?? null
    f.configuracoes.possui_logotipo = !!(payload?.logotipo_url)
    f.configuracoes.recibo_danfe = payload?.recibo_danfe ?? true
    f.configuracoes.exibe_sempre_ipi_danfe = payload?.exibe_sempre_ipi_danfe ?? true
    f.configuracoes.exibe_issqn_danfe = payload?.exibe_issqn_danfe ?? true
    f.configuracoes.exibe_impostos_adicionais_danfe = payload?.exibe_impostos_adicionais_danfe ?? true
    f.configuracoes.exibe_rastro_danfe = payload?.exibe_rastro_danfe ?? true
    f.configuracoes.exibe_unidade_tributaria_danfe = payload?.exibe_unidade_tributaria_danfe ?? true
    f.configuracoes.exibe_sempre_volumes_danfe = payload?.exibe_sempre_volumes_danfe ?? false
    f.configuracoes.ativo = payload?.ativo ?? true
    f.configuracoes.habilita_nfsen_producao = payload?.habilita_nfsen_producao ?? false
    f.configuracoes.habilita_nfsen_homologacao = payload?.habilita_nfsen_homologacao ?? true

    f.responsavel.nome_responsavel = payload?.nome_responsavel ?? ''
    f.responsavel.cpf_responsavel = payload?.cpf_responsavel ?? ''
    f.responsavel.login_responsavel = payload?.login_responsavel ?? ''
    f.responsavel.senha_responsavel = '' // write-only
    f.responsavel.senha_responsavel_preenchida = payload?.senha_responsavel_preenchida ?? false
  },

  [types.SET_CARREGANDO_DADOS] (state, payload) {
    state.flagsDeControle.carregandoDados = {
      status: payload.status,
      mensagem: payload.mensagem || ''
    }
  },

  [types.SET_MANIPULANDO_DADOS] (state, payload) {
    state.flagsDeControle.manipulandoDados = {
      status: payload.status,
      mensagem: payload.mensagem || ''
    }
  }
}
